import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AssistitiApi, TenantsApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useTenantsContattiDataSource(tenantId:string) {
    const { currentTenant } = useContext(TenantContext);
    const api = new TenantsApi(apiConfiguration);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getTenantContatti({ 
              tenantId: tenantId
            });
          },
    
          byKey: (key) => {
            return api.getTenantContattoById({
                tenantId: tenantId,
                contattoId: key
            });
          },
    
          insert: (values) => {
            return api.insertTenantContatto({
                tenantId: tenantId, 
                tenantContattoCreateDTO: values
            });
          },
    
          update: (key, values) => {
            return api.updateTenantContatto({
                tenantId: tenantId,
                contattoId: key,
                tenantContattoUpdateDTO: values  
            });
          },
    
          remove: (key) => {
            return api.deleteTenantContatto({
                tenantId: tenantId,
                contattoId: key
            });
          }
        });
      }, [currentTenant]);
    
      return dataSource;
}


